export const OTHER_OPTION_ISO = 12;
export const OTHER_OPTION_SBA = 13;

// ASC sorts must be odd, DEC sorts must be even
export const SORT_COMPANY_ASC = 15;
export const SORT_COMPANY_DESC = 16;
export const SORT_CONTRACT_ASC = 17;
export const SORT_CONTRACT_DESC = 18;
export const SORT_GROUP_ASC = 19;
export const SORT_GROUP_DESC = 20;
export const SORT_NAME_ASC = 23;
export const SORT_NAME_DESC = 24;
export const SORT_EMAIL_ASC = 25;
export const SORT_EMAIL_DESC = 26;
export const SORT_STN_ASC = 27;
export const SORT_STN_DESC = 28;
export const SORT_ORDER_NUMBER_ASC = 29;
export const SORT_ORDER_NUMBER_DESC = 30;
export const SORT_RFQ_ASC = 31;
export const SORT_RFQ_DESC = 32;
export const SORT_AWARD_DATE_ASC = 33;
export const SORT_AWARD_DATE_DESC = 34;
export const SORT_DELIVERY_DATE_ASC = 35;
export const SORT_DELIVERY_DATE_DESC = 36;
export const SORT_ORDER_TOTAL_ASC = 37;
export const SORT_ORDER_TOTAL_DESC = 38;
export const SORT_ORDER_STATUS_ASC = 39;
export const SORT_ORDER_STATUS_DESC = 40;
export const SORT_SITE_NAME_ASC = 41;
export const SORT_SITE_NAME_DESC = 42;
export const SORT_CONTRACT_DATE_ASC = 43;
export const SORT_CONTRACT_DATE_DESC = 44;
export const SORT_SHORT_AGENCY_NAME_ASC = 45;
export const SORT_SHORT_AGENCY_NAME_DESC = 46;

export const SEARCH_TYPE_NAME = 21;
export const SEARCH_TYPE_ALL = 22;

export const MAX_NUM_DOCS_DISPLAY = 6;

export const PAGE_TYPE_DETAIL = "detail";
export const PAGE_TYPE_CH_GROUP = "contractholderslist";
export const PAGE_TYPE_PROGRAM_MANAGERS = "programmanagers";
export const PAGE_TYPE_SMALL_BUSINESS = "smallbusinesslist";
export const PAGE_TYPE_BUSINESS_BREAKDOWN = "businessbreakdown";
export const PAGE_TYPE_ORDERS_LIST = "orderslist";

export const NAICS_ELECTRONIC_COMPUTER_MANUFACTURING = "334111";
export const NAICS_OTHER_COMPUTER_RELATED_SERVICES = "541519";

export const GROUP_A_OPTION = "Group A";
export const GROUPS_BCD_OPTION = "Groups B,C,D";

export const WOSB = "WOSB";
export const HUBZONE = "HUBZone";
export const SDVOSB = "SDVOSB";
export const EDWOSB = "EDWOSB";
export const VOSB = "VOSB";
export const SMALL_BUSINESS = "Small Business";
export const OTHER_THAN_SMALL = "Other Than Small";

export const FLAG_YES = "Y";
export const FLAG_NO = "N";

export const GROUP_A = "A";
export const GROUP_B = "B";
export const GROUP_C = "C";
export const GROUP_D = "D";
export const GROUP_TOTAL = "Total";

export const CATEGORY_TOTAL = 0;
export const CATEGORY_1 = 1;
export const CATEGORY_2 = 2;

export const GENERIC_ERROR_STRING =
  "An error has occurred. Please contact the helpdesk at help@sewp.nasa.gov for support.";
export const GENERIC_LOADING_STRING = "Loading data...";

// Internal Cron report types that require additional inputs
export const REPORT_OPTIONS_LIST = ["agencyCatalog"];

export const HELP_EMAIL_ADDRESS = "help@sewp.nasa.gov";

export const ORDER_APP_PAGE_SIZE = 10;

export const PAGINATION_STATUS_SELECTED = "active";
export const PAGINATION_STATUS_DISABLED = "disabled";
export const PAGINATION_STATUS_CLICKABLE = "clickable";

/**@type {ContractHolderBanInfo[]} */
export const BANNED_CHS = [];

export const WHITELIST = "whitelist";
export const BLACKLIST = "blacklist";

export const EVENT_CODE_ENTER = "Enter";

export const DEFAULT_REST_PAGE_NUMBER = 1;
export const DEFAULT_REST_PAGE_SIZE = 10;

export const UNSPSC_TAB_DRILLDOWN = "drilldown";
export const UNSPSC_TAB_PN_SEARCH = "pn search";

export const UNSPSC_APPROVED_FLAG_APPROVED = "A";
export const UNSPSC_APPROVED_FLAG_LIMITED = "L";

export const UNSPSC_APPROVAL_LEVEL_FLAG_SEGMENT = "S";
export const UNSPSC_APPROVAL_LEVEL_FLAG_FAMILY = "F";
export const UNSPSC_APPROVAL_LEVEL_FLAG_CLASS = "C";

export const UNSPSC_PROVIDER_STATUS_PRIMARY = "P";
export const UNSPSC_PROVIDER_STATUS_ALTERNATE = "A";

export const CH_PP_RATING_EXCELLENT = "Excellent";
export const CH_PP_RATING_VERY_GOOD = "Very Good";
export const CH_PP_RATING_GOOD = "Good";
export const CH_PP_RATING_FAIR = "Fair";
export const CH_PP_RATING_POOR = "Poor";
export const CH_PP_RATING_NEUTRAL = "Neutral";

export const JWTNAME = "JWT-SEWP";